import {
  collection,
  doc,
  getDoc,
  type CollectionReference,
  type FirestoreError,
} from "firebase/firestore";
import { firestore } from "@/helpers/firebase/firebase";
import { handleFirestoreException } from "@/helpers/exceptions/handler";
import { quotaDocumentConverter } from "@kekkle/shared/convertors/web/quota-document.converter";
import type { QuotaDocument } from "@kekkle/shared/types/documents/quota-document/quota-document";

function quotaCollection(userUuid: string): CollectionReference<QuotaDocument> {
  return collection(firestore, "users", userUuid, "quota").withConverter(
    quotaDocumentConverter,
  );
}

export async function fetchPhotoUploadQuota(
  userUuid: string,
): Promise<QuotaDocument | null> {
  try {
    const quotaDoc = await getDoc(
      doc(quotaCollection(userUuid), "photo_uploads"),
    );
    if (!quotaDoc.exists()) {
      return null;
    }
    return quotaDoc.data();
  } catch (e) {
    handleFirestoreException({ e: e as FirestoreError });
    throw e;
  }
}

export async function fetchShortUploadQuota(
  userUuid: string,
): Promise<QuotaDocument | null> {
  try {
    const quotaDoc = await getDoc(
      doc(quotaCollection(userUuid), "short_uploads"),
    );
    if (!quotaDoc.exists()) {
      return null;
    }
    return quotaDoc.data();
  } catch (e) {
    handleFirestoreException({ e: e as FirestoreError });
    throw e;
  }
}

export function isQuotaExceeded(quota: QuotaDocument): boolean {
  return (
    quota.daily_count >= quota.daily_limit ||
    quota.weekly_count >= quota.weekly_limit ||
    quota.total_count >= quota.total_limit
  );
}
